import axios from 'axios';
import { setLogout } from '../state';

// Create an axios instance
const ieqipCoreServiceApi = axios.create({
    baseURL: process.env.REACT_APP_IEQIP_CORE_SERVICE_API_URL
});

// Create a function to setup the interceptors that takes dispatch as a parameter
export const setupInterceptors = (dispatch) => {
    ieqipCoreServiceApi.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            // Only logout for 401 Unauthorized
            if (error.response?.status === 401) {
                console.log("401 Unauthorized - Logging out user");
                dispatch(setLogout());
            } 
            // Handle network errors (no response received)
            else if (error.request) {
                console.log('Network error - No response received:', error.request);
                dispatch(setLogout());
            } 
            // Handle CORS errors
            else if (error.message?.includes('Network Error') || error.message?.includes('CORS')) {
                console.log('Network/CORS error:', error.message);
                dispatch(setLogout());
            }
            // For all other errors (including 500), just log and reject
            else {
                console.log('API error:', error.message);
            }
            return Promise.reject(error);
        }
    );
};

export default ieqipCoreServiceApi;
